import React from 'react';
import { motion } from 'framer-motion';
const fears = [{
  icon: '⏰',
  title: 'Postergás sin querer',
  description: '"Lo hago después", "hay tiempo"... hasta que un día ya no lo hay. Y ese día llega más rápido de lo que pensás.'
}, {
  icon: '💭',
  title: 'Nunca le preguntaste',
  description: '¿Sabés cómo era la infancia de tu mamá? ¿Qué la hizo quien es hoy? Hay toda una vida que todavía no conocés.'
}, {
  icon: '💔',
  title: 'Miedo al olvido',
  description: 'Que tus hijos no puedan conocer a su abuela como realmente fue. Que su historia se pierda para siempre.'
}, {
  icon: '🎁',
  title: 'No encontrás el regalo',
  description: 'Cada año lo mismo: nada parece suficiente ni tiene el peso emocional que estás buscando para ella.'
}];
export function FearCards() {
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-107">
      <div className="max-w-6xl mx-auto" data-id="element-108">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-109">
          {fears.map((fear, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-50 rounded-lg p-6 border-l-4 border-[#E8440A] hover:shadow-lg transition-shadow" data-id="element-110">
              <div className="text-4xl mb-4" data-id="element-111">{fear.icon}</div>
              <h3 className="text-xl font-bold text-[#1A1A1A] mb-3" data-id="element-112">
                {fear.title}
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-113">
                {fear.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}